import './bootstrap';
import './mobile-menu';
import './sliders';
import './modal';
import './theme';
import Collage           from "./collage/Collage";
import DictionaryListing from './DictionaryListing';
import DictionaryCookie  from './DictionaryCookie';
import DictionaryGame    from './DictionaryGame';
import Videos            from './Videos.js';
import AudioManager      from './AudioManager.js';
import Jigsaw            from './jigsaw/Jigsaw.js';
import SvgSpriteMaker    from './jigsaw/SvgSpriteMaker.js';
import DictionaryIndex from "./DictionaryIndex.js";

import.meta.glob( [
    '../images/**/**.png',
    '../images/**/**.jpg',
    '../images/**/**.svg',
    '../fonts/**',
] );

console.info( 'JS compiled at %c' + __VITE_COMPILATION_DATE__, 'background: green;' );

const dictionaryCookie = new DictionaryCookie();
const audioManager     = new AudioManager();
document.addEventListener( 'DOMContentLoaded', () =>
{
    const canvas = document.querySelector( "#canvas" );

    if ( canvas )
    {
        window.collage = new Collage( canvas );
        window.collage.prepareDraggable();
        window.collage.prepareClickable();

        window.seed = new Date().getTime();
    }


    // plase keep the cookie class first ( dictionaryCookie )
    const dictionaryListing = new DictionaryListing();
    const dictionaryGame    = new DictionaryGame();

    const videosToInject = document.querySelectorAll( '.inject-video' );
    if ( videosToInject )
    {
        Array.from( videosToInject ).forEach( video => new Videos( video ) );
    }


    if ( !document.body.classList.contains( 'dictionnary' ) )
    {
        const jigsaws = document.querySelectorAll( '.jigsaw-container' );
        if ( jigsaws )
        {
            Array.from( jigsaws ).forEach( jigsaw => new Jigsaw( jigsaw, true ) )
        }
    }


    const dictionaryIndex = new DictionaryIndex();


    // const puzzlePiecesSvgs = document.querySelectorAll( '.puzzles-in .puzzle-pieces' );
    // if ( puzzlePiecesSvgs )
    // {
    //
    //     Array.from( puzzlePiecesSvgs ).forEach( piecesSvg => new SvgSpriteMaker( piecesSvg ) )
    // }

} );


